export default __webpack_public_path__ + "static/media/D2.096b8a40.svg";